export const close = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 14L14 2M14 14L2 2"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </svg>
);
